export default __webpack_public_path__ + "static/media/file-loaded.9852d22d.svg";